module.exports = __webpack_public_path__ + "static/media/15UN-Habitat3.64da1c39.jpg";